<style>
.owl-carousel {
  padding: 0px 50px;
}

.owl-carousel.owl-drag .owl-item {
  padding: 15px 0px 15px;
}

.owl-carousel .item .img {
  object-fit: cover;
  margin: 0px auto;
  width: 100%;
  height: 100%;
  max-height: 128px;
  max-width: 148px;
}

.owl-carousel .owl-prev {
  position: absolute;
  left: 5px;
}

.owl-carousel .owl-next {
  position: absolute;
  right: 5px;
}

.owl-carousel .owl-nav .owl-prev:before {
  font-family: 'Font Awesome 5 Free';
  content: '\f104';
  display: inline-block;
  vertical-align: middle;
  font-weight: 900;
}

.owl-carousel .owl-nav .owl-next:after {
  font-family: 'Font Awesome 5 Free';
  content: '\f105';
  display: inline-block;
  vertical-align: middle;
  font-weight: 900;
}

.owl-theme .owl-nav [class*='owl-'] {
  color: #ed670c;
  font-size: 3.5em;
  background: none;
  cursor: pointer;
  display: inline-block;
  border-radius: 0px;
  padding: 0px 0px;
  margin: 5px;
  top: 25px;
}

.owl-theme .owl-nav [class*='owl-']:hover {
  color: #b54900;
  background: none;
  text-decoration: none;
}

.allAssessments {
  margin-top: 50px;
}
.assessments {
  padding: 20px 10px;
  margin: 20px 0;
  background: #fff;
  border-radius: 5px;
}
.btnAssessments {
  float: right;
  color: #fff;
}
.textAssessments {
  float: right;
  font-weight: 800;
  color: rgb(243, 61, 61);
  cursor: pointer;
}
.textAssessment {
  font-weight: 800;
  color: rgb(224, 153, 153);
  cursor: pointer;
  text-align: center;
}
.name {
  font-size: 1.75rem;
}
.estrelas input[type='radio'] {
  display: none;
}
.estrelas label i.fa:before {
  content: '\f005';
  color: #fc0;
}
.estrelas input[type='radio']:checked ~ label i.fa:before {
  color: #ccc;
}
.dateEstrela {
  position: absolute;
  top: -25px;
  right: 40px;
}
.btn:focus,
.btn.focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 0 !important;
  box-shadow: 0 0 0 0 !important;
}
.btn:focus,
.btn.focus-visible {
  outline: 0;
  -webkit-box-shadow: 0 0 0 0 !important;
  box-shadow: 0 0 0 0 !important;
}
.btn-dialog:focus {
  box-shadow: 0 0 0 0;
  border: 0 none;
  outline: 0;
}
.btn-dialog i {
  color: #cccccc;
}
.dialogMenu {
  position: absolute;
  top: -25px;
  right: 10px;
  color: #b9b9b9;
}
.assessmentsDate {
  position: absolute;
  top: 35px;
  font-size: 15px;
  color: rgb(177, 177, 177);
}
</style>

<template>
  <div class="guia-profissional-single">
    <div class="head-banner">
      <div class="box-img">
        <img
          class="img-fluid obj h-100"
          src="@/assets/img/banner-head-100.jpg"
          alt="Banner Promoção"
        />
      </div>
    </div>
    <div class="guia-head pb-100">
      <div class="container" v-if="profissional">
        <!-- Breadcrumb -->
        <div class="row p-25">
          <div class="col-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item" id="inicio">
                  <router-link class="text-uppercase" :to="{ name: 'home' }"
                    >Início</router-link
                  >
                </li>
                <li class="breadcrumb-item">
                  <router-link
                    class="text-uppercase"
                    :to="{ name: 'guia-profissionais-geral' }"
                  >
                    Guia de Profissionais
                  </router-link>
                </li>
                <li
                  class="breadcrumb-item active text-uppercase"
                  aria-current="page"
                >
                  Profissional
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <!-- Guia head -->
        <div class="row">
          <!-- Título da Sessão -->
          <div class="col-12 text-center mb-4">
            <h1 class="h1-after-center text-uppercase fwb mb-5">
              Profissional
            </h1>
            <p class="roboto-n text-center">
              A Constr Up, buscou de uma maneira rápida e fácil te oferecer os
              prestadores de serviço da sua região, é só escolher a cidade e o
              serviço que deseja.
            </p>
            <p class="fs-14 roboto-n text-center c-orange">
              <span class="font-weight-bold">Atenção!</span>A Constr Up não se
              responsabiliza pelos serviços prestados. Apresentamos apenas os
              prestadores de serviço de sua região.
            </p>
          </div>
          <!-- Card Single -->
          <div class="col-12 mb-5">
            <div class="card-proff-g">
              <div class="row">
                <div class="col-md-6 mb-4">
                  <div class="star" v-if="profissional.plano_id >= 3">
                    <i class="fas fa-star fs-16 c-white"></i>
                    <span class="fs-14 text-uppercase c-white">Destaque</span>
                  </div>
                  <div class="box-img">
                    <img
                      class="my-img-fluid w-100 h-100"
                      :src="
                        `${getImagesAddress}` + profissional[0].foto_principal
                      "
                      alt
                      v-if="profissional[0].foto_principal !== null"
                    />
                    <img
                      class="obj max-obj-contain my-img-fluid w-100 h-100"
                      src="@/assets/img/Logo Novo ConstrUp.png"
                      alt="Profissional sem foto. Foto padrão da Constr Up"
                      v-else
                    />
                  </div>
                </div>
                <div class="col-md-6 mb-4">
                  <div class="avaliable" v-if="dados.nota >= 0">
                    <span class="mr-1">{{ dados.estrela }}</span>
                    <span class="Fam1ne EBe2gf">
                      <span :style="{ width: dados.nota + 'px' }"></span>
                    </span>
                  </div>

                  <div class="box-info">
                    <h3 v-if="this.profissional[0].nome_fantasia">
                      {{ this.profissional[0].nome_fantasia }}
                    </h3>
                    <h3 v-else-if="this.profissional[0].nome !== ''">
                      {{ this.profissional[0].nome }}
                    </h3>
                    <p class="pb-2 border-bottom text-justify">
                      {{ this.profissional[0].profissional_resumo }}
                    </p>
                    <div
                      class="mb-1 mt-2"
                      v-if="profissional[0].profissoes !== null"
                    >
                      <i class="fas fa-user c-black"></i>
                      <span
                        class="roboto-n"
                        v-for="(profissao, index) in profissional[0].profissoes"
                        :key="index"
                      >
                        {{ profissao.nome }}
                        <span
                          v-if="
                            parseInt(index) + 1 !==
                            profissional[0].profissoes.length
                          "
                          >,</span
                        >
                      </span>
                    </div>
                    <div class="mb-1" v-else>
                      <i class="fas fa-user c-black mr-2"></i>
                      <span class="roboto-n">Sem Profissão</span>
                    </div>
                    <div
                      class="mb-1"
                      v-if="
                        this.profissional[0].cidade !== null &&
                        this.profissional[0].estado !== null
                      "
                    >
                      <i class="fas fa-map-marker-alt c-black mr-2"></i>
                      <span class="roboto-n">
                        {{ this.profissional[0].cidade.nome }} -
                        {{ this.profissional[0].estado.uf }}</span
                      >
                    </div>
                    <div
                      class="mb-1"
                      v-if="
                        this.profissional[0].celular !== null &&
                        this.profissional[0].celular !== ''
                      "
                    >
                      <i class="fab fa-whatsapp c-black mr-2"></i>
                      <a
                        :href="'tel:+' + this.profissional[0].celular"
                        class="roboto-n c-black"
                        >{{ this.profissional[0].celular }}</a
                      >
                    </div>
                    <div
                      class="mb-1"
                      v-if="
                        this.profissional[0].telefone !== null &&
                        this.profissional[0].telefone !== ''
                      "
                    >
                      <i class="fas fa-phone c-black mr-2"></i>
                      <a
                        :href="'tel:+' + this.profissional[0].telefone"
                        class="roboto-n c-black"
                        >{{ this.profissional[0].telefone }}</a
                      >
                    </div>
                    <div
                      class="mb-1"
                      v-if="
                        this.profissional[0].usuario !== null &&
                        this.profissional[0].usuario !== ''
                      "
                    >
                      <i class="fas fa-envelope c-black mr-2"></i>
                      <a
                        :href="'mailto:' + this.profissional[0].usuario"
                        class="roboto-n c-black"
                        >{{ this.profissional[0].usuario }}</a
                      >
                    </div>
                    <div
                      class="mb-1"
                      v-if="
                        profissional[0].links !== null &&
                        profissional[0].links.length > 0
                      "
                    >
                      <a
                        :href="link.link"
                        class="roboto-n"
                        v-for="(link, index) in profissional[0].links"
                        target="_blank"
                        :key="index"
                      >
                        <i class="fas fa-link c-black mr-2"></i>
                        {{ link.link }}
                        <span
                          v-if="
                            parseInt(index) + 1 !== profissional[0].links.length
                          "
                        >
                          <br />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <LightBox
                    v-if="trabalhos !== undefined"
                    :images="trabalhos"
                    ref="lightbox"
                    :show-caption="true"
                    :show-light-box="false"
                  ></LightBox>
                  <div v-else>
                    Esse profissional não colocou nenhuma foto do seu trabalho.
                  </div>
                </div>
                <div
                  class="col-12"
                  v-if="
                    profissional[0].trabalhos !== null &&
                    profissional[0].trabalhos.length > 0
                  "
                >
                  <OwlCarousel
                    :autoplay="true"
                    :nav="true"
                    :navText="['', '']"
                    :dots="false"
                    :responsive="{
                      0: { items: 1 },
                      576: { items: 1 },
                      768: { items: 3 },
                      900: { items: 3 },
                      1200: { items: 3 },
                      1366: { items: 5 },
                      1920: { items: 5 },
                    }"
                  >
                    <div
                      class="item"
                      v-for="(trabalho, index) in profissional[0].trabalhos"
                      :key="index"
                    >
                      <img
                        class="img"
                        :src="`${getImagesAddress}` + trabalho.nome_foto"
                        @click="imageModal(index)"
                      />
                    </div>
                  </OwlCarousel>
                </div>
                <div class="col-12 mt-5">
                  <div class="btnAssessments" v-if="dadosUsuario">
                    <a @click.prevent="assessments" class="btn btn-primary"
                      >Avaliar</a
                    >
                  </div>
                  <div class="textAssessments" v-if="!dadosUsuario">
                    <span @click="$bvModal.show('login')"
                      >Faça o login para fazer uma Avaliação</span
                    >
                  </div>
                  <div class="allAssessments" v-if="dados.dados != null">
                    <div
                      class="assessments"
                      v-for="(dado, i) in dados.dados"
                      :key="i"
                    >
                      <div class="name">
                        <div class="row">
                          <div class="col-8">
                            <span>{{ dado.nome }}</span>
                          </div>
                          <div class="col-4">
                            <div class="dialogMenu">
                              <b-dropdown no-caret dropleft variant="dialog">
                                <template #button-content>
                                  <i class="fas fa-ellipsis-v"></i>
                                </template>
                                <b-dropdown-item
                                  @click.prevent="report(dado.id)"
                                  >Denunciar</b-dropdown-item
                                >
                              </b-dropdown>
                            </div>
                            <div class="dateEstrela" v-if="dados.nota >= 0">
                              <span class="Fam1ne EBe2gf">
                                <span
                                  :style="{ width: dado.newEstrela + 'px' }"
                                ></span> </span
                              ><br />
                              <span class="assessmentsDate">{{
                                dado.date
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text">
                        {{ dado.mensagem }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="call-proff bg-gray-3 p-50">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-10">
            <div class="row align-items-center">
              <div class="col-lg-6 mb-lg-0 mb-4">
                <h1 class="text-lg-left text-center text-uppercase c-white">
                  Crie seu cadastro, divulgue seus serviços e
                  <span class="c-yellow">feche negócios</span>.
                </h1>
              </div>
              <div class="col-lg-6 text-center">
                <router-link
                  class="btn bg-orange c-white text-uppercase py-2 px-5"
                  :to="{ name: 'cadastro' }"
                  >Quero me cadastrar</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="guia-destaques p-100" v-if="profissionais !== []">
      <div class="container">
        <div class="row">
          <div class="col-12 mb-4">
            <h1 class="h1-after text-uppercase fwb mb-5">
              Profissionais Relacionados
            </h1>
          </div>
          <div
            class="col-lg-3 col-md-6 mb-5 mb-5"
            v-for="(profissionalSingle, index) in profissionais"
            :key="index"
          >
            <div class="card-proff-sm" v-if="profissionalSingle !== null">
              <div class="star" v-if="profissionalSingle.plano_id >= 3">
                <i class="fas fa-star fs-16 c-white"></i>
                <span class="fs-14 text-uppercase c-white">Destaque</span>
              </div>
              <div class="box-img">
                <img
                  class="my-img-fluid w-100 h-100"
                  :src="
                    `${getImagesAddress}` + profissionalSingle.foto_principal
                  "
                  alt
                  v-if="profissionalSingle.foto_principal !== null"
                />
                <img
                  class="obj max-obj-contain my-img-fluid w-100 h-100"
                  src="@/assets/img/Logo Novo ConstrUp.png"
                  alt
                  v-else
                />
              </div>
              <div class="box-info pt-2">
                <p
                  class="fs-12 fwb mb-2"
                  v-if="profissionalSingle.nome_fantasia !== null"
                >
                  {{ profissionalSingle.nome_fantasia }}
                </p>
                <p
                  class="fs-12 fwb mb-2"
                  v-else-if="profissionalSingle.nome !== null"
                >
                  {{ profissionalSingle.nome }}
                </p>
                <div v-if="profissionalSingle.profissoes !== null">
                  <i class="fas fa-user fs-12 c-black mr-1"></i>
                  <span
                    class="roboto-n fs-12"
                    v-for="(profissao, index) in profissionalSingle.profissoes"
                    :key="index"
                  >
                    {{ profissao.nome }}
                    <span
                      v-if="
                        parseInt(index) + 1 !==
                        profissionalSingle.profissoes.length
                      "
                      >,</span
                    >
                  </span>
                </div>
              </div>
              <div
                v-if="
                  profissionalSingle.cidade !== null &&
                  profissionalSingle.estado !== null
                "
              >
                <i class="fas fa-map-marker-alt fs-12 c-black mr-2"></i>
                <span class="roboto-n fs-12"
                  >{{ profissionalSingle.cidade.nome }} -
                  {{ profissionalSingle.estado.uf }}</span
                >
              </div>
              <div
                v-if="
                  profissionalSingle.celular !== null &&
                  profissionalSingle.celular !== ''
                "
              >
                <i class="fab fa-whatsapp fs-12 c-black mr-1"></i>
                <a href="tel:+" class="roboto-n fs-12 c-black">{{
                  profissionalSingle.celular
                }}</a>
              </div>
              <router-link
                class="btn btn-sm btn-avaliable w-100 c-white mt-2"
                :to="{
                  name: 'guia-profissionais-single',
                  params: { id: profissionalSingle.id },
                }"
                >Ver Mais</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="success" size="lg" centered hide-footer>
      <div class="d-block text-center">
        <img class="max-obj-contain" :src="imagemModal" />
      </div>
    </b-modal>
    <b-modal title="Nova Avaliação" ref="modalAssessments" centered hide-footer>
      <div class="d-block">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label> Sua Avaliação </label>
              <div class="estrelas">
                <input
                  type="radio"
                  id="cm_star-empty"
                  name="fb"
                  value=""
                  checked
                />
                <label for="cm_star-1" @click="sendStart(1)"
                  ><i class="fa"></i
                ></label>
                <input type="radio" id="cm_star-1" name="fb" value="1" />
                <label for="cm_star-2" @click="sendStart(2)"
                  ><i class="fa"></i
                ></label>
                <input type="radio" id="cm_star-2" name="fb" value="2" />
                <label for="cm_star-3" @click="sendStart(3)"
                  ><i class="fa"></i
                ></label>
                <input type="radio" id="cm_star-3" name="fb" value="3" />
                <label for="cm_star-4" @click="sendStart(4)"
                  ><i class="fa"></i
                ></label>
                <input type="radio" id="cm_star-4" name="fb" value="4" />
                <label for="cm_star-5" @click="sendStart(5)"
                  ><i class="fa"></i
                ></label>
                <input type="radio" id="cm_star-5" name="fb" value="5" />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="nome"> Mensagem </label>
              <textarea
                class="form-control"
                type="text"
                v-model="form.mensagem"
                placeholder="Conte como foi sua experiência com esse profissional"
              >
              </textarea>
            </div>
          </div>
          <div class="btnAssessments ml-3">
            <a @click.prevent="sendAssessments" class="btn btn-primary"
              >Enviar</a
            >
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal title="Denunciar Avaliação" ref="modalReport" centered hide-footer>
      <div class="d-block">
        <div class="row" v-if="dadosUsuario">
          <div class="col-md-12">
            <div class="form-group">
              <label>O que há de errado com esta avaliação?</label>
              <textarea
                maxlength="254"
                class="form-control"
                type="text"
                v-model="msg.mensagem"
                placeholder="Conte o que há de errado com esta avaliação?"
              >
              </textarea>
            </div>
          </div>
          <div class="btnAssessments ml-3">
            <a @click.prevent="sendReports" class="btn btn-primary">Enviar</a>
          </div>
        </div>
        <div class="textAssessment" v-if="!dadosUsuario">
          <span @click="$bvModal.show('login')"
            >Faça o login para fazer uma denuncia na avaliação!</span
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import OwlCarousel from "vue-owl-carousel";
import LightBox from "vue-image-lightbox";
import UserTypes from "../../enums/UserTypes";
import scrollToElement from '../../mixins/scrollToElement';

export default {
  mixins:[scrollToElement],
  name: "guia-profissional-single",
  data: () => ({
    imagemModal: null,
    UserTypes,
    dados: {
      nota: null,
    },
    msg: {
      id: null,
      mensagem: null,
    },
    form: {
      nome: null,
      nota: null,
      mensagem: null,
      usuario_id: null,
      profissional_id: null,
    },
  }),
  props: ['id'],
  components: { OwlCarousel, LightBox },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
      profissional: (state) => state.profissional,
      profissionais: (state) => state.profissionais,
      trabalhos: (state) => {
        if (state.profissional !== null) {
          if (state.profissional[0].trabalhos !== null) {
            const trabalhos = [];
            // eslint-disable-next-line no-restricted-syntax
            for (const index in state.profissional[0].trabalhos) {
              trabalhos.push({
                thumb:
                  process.env.VUE_APP_IMAGES_ADDRESS +
                  state.profissional[0].trabalhos[index].nome_foto,
                src:
                  process.env.VUE_APP_IMAGES_ADDRESS +
                  state.profissional[0].trabalhos[index].nome_foto,
              });
            }
            return trabalhos;
          }
        }
      },
    }),
  },
  mounted() {
   this.scrollToElement();
  },
  created() {
    this.scrollToElement();
    this.carregarPagina();
    this.$store.dispatch('addOneView', this.id);
    if (this.$route.params.id) {
      this.createAssessments(this.$route.params.id);
    }
  },
  activated() {
    this.carregarPagina();
  },
  watch: {
    '$route.params.id': function (id) {
      this.carregarPagina();
    },
  },
  methods: {
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    sendStart(id) {
      this.form.nota = id;
    },
    createAssessments(id) {
      this.$store
        .dispatch('getAssessments', id)
        .then((response) => {
          this.dados = response.data;
        })
        .catch(() => {
          this.aviso('Erro ao carregar avaliações!', 'danger');
        });
    },
    sendReports() {
      if (this.msg.id === null || this.msg.mensagem === null) {
        this.aviso(
          'Preencha todos os campos para enviar a sua denuncia!',
          'danger'
        );
        return;
      }
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('saveReport', this.msg)
        .then((response) => {
          const res = response.data;
          this.$store.dispatch('endLoader');
          this.$refs.modalReport.hide();
          this.aviso(res.message, res.type);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.$refs.modalReport.hide();
          this.aviso(
            'Erro ao enviar sua denuncia, tente novamente mais tarde!',
            'danger'
          );
        });
    },
    sendAssessments() {
      if (this.form.nota === null || this.form.mensagem === null) {
        this.aviso(
          'Preencha todos os campos para enviar a sua avaliação!',
          'danger'
        );
        return;
      }

      this.form.profissional_id = this.$route.params.id;
      this.form.usuario_id = this.dadosUsuario.id;
      this.form.nome = this.dadosUsuario.nome_usuario;

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('saveAssessments', this.form)
        .then((response) => {
          const res = response.data;
          this.$store.dispatch('endLoader');
          this.$refs.modalAssessments.hide();
          this.aviso(res.message, res.type);
          this.createAssessments(this.$route.params.id);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.$refs.modalAssessments.hide();
          this.aviso(
            'Erro ao enviar sua avaliação, tente novamente mais tarde!',
            'danger'
          );
        });
    },
    report(id) {
      this.msg.id = id;
      this.$refs.modalReport.show();
    },
    assessments() {
      this.$refs.modalAssessments.show();
    },
    carregarPagina() {
      const self = this;

      this.$store.dispatch('emptyProfissional').then(() => {
        this.$store.dispatch('startLoader');
        setTimeout(() => {
          self.$store
            .dispatch('showProfissional', this.id)
            .then(() => {
              setTimeout(() => {
                self.$store.dispatch('endLoader');
              }, 1000);
            })
            .catch(() => {
              setTimeout(() => {
                self.$store
                  .dispatch('showProfissional', this.id)
                  .then(() => {
                    setTimeout(() => {
                      self.$store.dispatch('endLoader');
                    }, 1000);
                  })
                  .catch(() => {
                    self.$store.dispatch('endLoader');
                    self.aviso(
                      'Não foi possível carregar o profissional! Tente novamente em 5 minutos!',
                      'danger'
                    );
                  });
              }, 1000);
            });
        }, 1000);
      });

      this.$store.dispatch('emptyProfissionais').then(() => {
        this.$store.dispatch('startLoader');
        setTimeout(() => {
          self.$store
            .dispatch('showProfissionalRelacionados', this.id)
            .then(() => {
              setTimeout(() => {
                self.$store.dispatch('endLoader');
              }, 2000);
            })
            .catch(() => {
              setTimeout(() => {
                self.$store
                  .dispatch('showProfissionalRelacionados', this.id)
                  .then(() => {
                    //   self.$store.dispatch('endLoader');
                  })
                  .catch(() => {
                    // self.$store.dispatch('endLoader');
                  });
              }, 1000);
            });
        }, 1000);
      });
    },
    copyLink() {
      const copyText = this.urlSite;
      copyText.select();
      document.execCommand('copy');
      this.aviso('Copiado com sucesso!', 'success');
    },
    imageModal(index) {
      this.$refs.lightbox.showImage(index);
    },
  },
};
</script>
